import { createContext } from 'react'
import Member from 'iam/models/Member'

/**
 * Current Member context.
 */
export const CurrentMemberContext = createContext<Member>(Member.none)
